module.exports = __webpack_public_path__ + "img/client_2.33099ce7.png";